import ZkRoleLayout from './src/main'
ZkRoleLayout.install = function (Vue) {
  Vue.component(ZkRoleLayout.name, ZkRoleLayout)
}
export default ZkRoleLayout



// WEBPACK FOOTER //
// ./src/cdpBase/baseComponents/roleLayout/index.js